import { Link } from "react-router-dom";
import ItemCard from "../../../components/itemCard";

const ServicesThirdSection = () => {



  const DataCard = [
    {
      imageSrc: require("../../../assets/Service/section1.png"),
      title: <><span>Sales and Marketing</span></>,
      description: "We offer tailored sales and marketing services to promote advanced imaging solutions. Our team creates strategic plans, engages in industry conferences, scientific events, and workshops to stay connected with the healthcare community and showcase advancements in ultrasound technology. Through personalized consultations and a customer-focused approach, we ensure that each client receives the right solution to enhance diagnostic capabilities and patient care.",
      direction: "right",
    },
    {
      imageSrc: require("../../../assets/Service/section2.png"),
      title: <><span>Maintenance Services</span></>,
      description:"We offer reliable maintenance services to ensure optimal equipment performance and minimize downtime. Our skilled engineers handle installation, regular PPMs, repairs, and software updates, helping healthcare providers maintain smooth and accurate diagnostic operations.",
      direction: "left",
    }, {
      imageSrc: require("../../../assets/Service/section3.png"),
      title: <><span>Training and Education</span></>,
      description: "We offer thorough training and education services, including application training, biomed training, and ongoing updates. Our goal is to ensure healthcare professionals are confident and well-equipped to use the latest technology, optimizing patient care and diagnostic accuracy. ",
      direction: "right",
    }, {
      imageSrc: require("../../../assets/Service/section4.png"),
      title: <><span>Upgrading Services</span></>,
      description: "Our portfolio of upgrading services is designed to cover your needs, now and in the future. We collaborate with you to ensure your technology and processes remain reliable to keep you operating consistently and economically. Our Upgrade and trade-in services help you stay at the forefront of new hardware and software developments, extend the life of your equipment and get the most out of your technology.",
      direction: "left",
    },
  ];


  return (
    <div className="App bg-white">
      <header className="App-header m-auto lg:px-0 lg:w-[80%] w-full p-5  py-20  ">
        <div>


       {DataCard.map((item, index) => (

            <>

              <ItemCard
                imageSrc={item.imageSrc}
                title={
                  <h3 className="text-[32px] leading-[40.64px]">
                    {item.title}
                  </h3>
                }
                description={item.description}
                direction={item.direction}
              />
              <br />
              <hr className="border-gray-color" />
              <br />
            </>

          ))}
       
    
 

          <br />

        </div>
      </header>
    </div>
  );
};

export default ServicesThirdSection;
